// extracted by mini-css-extract-plugin
export default {"component":"UZkFeR","mobile":"MNjP4c","sign":"WvEEj5"};